import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ShippingSettingsComponent = ({ selectLogisticsSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                        <InputContainer
                            label="Shipping Tracking Enabled"
                            name="IsShippingTrackingEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingSettings.IsShippingTrackingEnabled',
                                    selectLogisticsSettings?.ShippingSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingSettings?.IsShippingTrackingEnabled}
                        />
                        <InputContainer
                            label="Direct Shipment Enabled"
                            name="IsDirectShipmentEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingSettings.IsDirectShipmentEnabled',
                                    selectLogisticsSettings?.ShippingSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingSettings?.IsDirectShipmentEnabled}
                        />
                        <InputContainer
                            label="LSP Average PickupTime"
                            name="LSPAveragePickupTime"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ShippingSettings.LSPAveragePickupTime',
                                    selectLogisticsSettings?.ShippingSettings
                                )
                            }}
                            type="text"
                            value={selectLogisticsSettings?.ShippingSettings?.LSPAveragePickupTime}
                        />
                        <InputContainer
                            label="Disable Shipping Provider With VendorRole"
                            name="DisableShippingProviderWithVendorRole"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ShippingSettings.DisableShippingProviderWithVendorRole',
                                    selectLogisticsSettings?.ShippingSettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ShippingSettings?.DisableShippingProviderWithVendorRole}
                        />
                    </div>
                }
                expandedPanel="Shipping Settings"
                headerTitle="Shipping Settings"
            />
        </>
    )
}
export default ShippingSettingsComponent;
